module.exports = __webpack_public_path__ + "img/962d8a3.png";